import fetch from '@/common/utils/ftFetch'
const baseName = "/ylwebsqsserviceonline"

// 飞兔在线-平台建单
export const platformOrderApi = {
    // 商家任务单
    reqTaskList: sessionId => fetch.get(`${baseName}/thirdShopTaskPushRecord/listBySessionId?sessionId=${sessionId}`),
    // 推送任务单
    reqPush: reqData => fetch.post(`${baseName}/agent/session/pushShopTask`, reqData),
    // 工单列表
    reqOrderList: sessionId => fetch.get(`${baseName}/thirdWorkOrderPushRecord/listBySessionId?sessionId=${sessionId}`),
    // 推送工单
    reqPushOrder: reqData => fetch.post(`${baseName}/agent/session/pushWorkOrder`, reqData),
    // 创建淘天工单
    pushTaoTianWorkOrder: reqData => fetch.post(`${baseName}/agent/session/pushTaoTianWorkOrder`, reqData),
    // 获取淘天工单
    getTaoTianWorkOrder: sessionId => fetch.get(`${baseName}/agent/session/getTaoTianWorkOrder?sessionId=${sessionId}`)
}
